module.exports = __webpack_public_path__ + "static/spa01-bf2bcb81076b0c3243dcb926293040be.jpg";